const globalAfterSale = {
    path: "globalAfterSale",
    name: "globalAfterSale",
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'globalAfterSales',
        icon: 'HSIconfont hs-icon-a-firmwareinfo',
        showRealm: ['GLOBAL']
    },
    children: [
        {
            path: 'globalFirmware',
            name: 'globalFirmware',
            component: () => import('@/views/globalFirmware'),
            meta: { code: 'globalAfterSales:firmware' }
        },
        {
            path: 'globalSeries',
            name: 'globalSeries',
            component: () => import('@/views/globalSeries'),
            meta: { code: 'globalAfterSales:productSeries' }
        },
        {
            path: 'globalApModel',
            name: 'globalApModel',
            component: () => import('@/views/globalApModel'),
            meta: { code: 'globalAfterSales:apModel' }
        }
    ]
};
export default globalAfterSale;
